import { lazy } from 'react';

const CharityVettingFiscalBenefitsRoute = lazy(
  () => import('../components/steps/charity-fiscal-benefits-step/CharityFiscalBenefits'),
);

export default CharityVettingFiscalBenefitsRoute;
